import React from 'react';
import { MapPin } from 'lucide-react';
import { serviceAreas } from '../mock';

const GoogleMap = () => {
  // NYC center coordinates
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387193.30596073366!2d-74.25986548248684!3d40.69714941932609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY!5e0!3m2!1sen!2sus!4v1701234567890!5m2!1sen!2sus";

  return (
    <section className="py-20" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">Our Service Area</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Serving New York City and surrounding counties with 24/7 pest control services
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {/* Service Areas List */}
          <div className="lg:col-span-1">
            <div className="product-card">
              <h3 className="heading-3 mb-4">Areas We Serve</h3>
              <div className="space-y-3">
                {serviceAreas.map((area, index) => (
                  <div 
                    key={area.id}
                    className="flex items-center gap-3 p-3 rounded-lg transition-colors hover:bg-accent-wash"
                  >
                    <div 
                      className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ background: 'var(--accent-wash)' }}
                    >
                      <MapPin size={20} style={{ color: 'var(--accent-text)' }} />
                    </div>
                    <div>
                      <h4 
                        className="font-semibold body-medium"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        {area.name}
                      </h4>
                      <p className="caption" style={{ color: 'var(--text-muted)' }}>
                        24/7 Service Available
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 pt-6 border-t" style={{ borderColor: 'var(--border-light)' }}>
                <p className="body-small text-center" style={{ color: 'var(--text-secondary)' }}>
                  Same-day service available in all areas
                </p>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="lg:col-span-2">
            <div 
              className="rounded-2xl overflow-hidden border"
              style={{ 
                borderColor: 'var(--border-light)',
                height: '500px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            >
              <iframe
                src={mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="NY Pest & Exterminating Service Area Map"
              ></iframe>
            </div>
            
            {/* Map Info */}
            <div className="mt-4 text-center">
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                📍 Serving all 5 NYC boroughs plus Nassau, Suffolk, and Westchester counties
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleMap;
